import { UPDATE_PERSONAL_DETAILS, UPDATE_PERSONAL_DETAILS_SUCCESS } from '../storeTypes';

const INIT_STATE = {
  personalDetils: []
};

function personalDetilsReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case UPDATE_PERSONAL_DETAILS: {
      return {
        ...state,
        loader: true,
      };
    }
    case UPDATE_PERSONAL_DETAILS_SUCCESS: {
      return {
        ...state,
        loader: false,
        personalDetils: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
export default personalDetilsReducer;
